// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__wObuy","rotate":"CaptureVisa_style_rotate__zAiMP"};